import $ from 'jquery';


class SixBarPageLogic {
    constructor() {
    }

    init() {
        this.bindEvents();

        $(document).ready(e => {
            if (window.matchMedia('(max-width: 767px)').matches) {
                // The viewport is less than 768 pixels wide
            } else {
                // The viewport is at least 768 pixels wide
                $('.list-wrapper').parents('section').css('overflow-x', 'hidden');
            }
        });
    }

    bindEvents() {
        let open = false;
        function isBelow() {
            if ($(window).innerHeight() - $('.select-dropdown')[0].getBoundingClientRect().top < $('.select-dropdown').height() && !$('.select-dropdown').hasClass('dropup')) {
                return $('.select-dropdown').addClass('dropup');
            } else if ($(window).innerHeight() - $('.select-dropdown')[0].getBoundingClientRect().bottom > $('.select-dropdown').height()) {
                return $('.select-dropdown').removeClass('dropup');
            } else {
                return false;
            }
        }

        function isOpen() {
            if (open) {
                $('.select-opener').toggleClass('opener-active');
                $('.select-dropdown').toggleClass('show');
                isBelow();
                $('.select-wrapper').toggleClass('active');
            }
            else {
                $('.select-opener').toggleClass('opener-active');
                $('.select-dropdown').toggleClass('show');
                $('.select-wrapper').toggleClass('active');
            }
        }
        // on each click toggle the 'open' variable
        $('.select-div').click(e => {
            open = !open;
            isOpen();
        });
        // on each blur toggle the 'open' variable
        // fire only if menu is already in 'open' state
        $('.select-div').blur(e => {
            if (open) {
                open = !open;
                isOpen();
            }
        });
        // on ESC key toggle the 'open' variable only if menu is in 'open' state
        $(document).keyup(e => {
            if (e.keyCode === 27) {
                if (open) {
                    open = !open;
                    isOpen();
                }
            }
        });

        $('.dropdown-list li').click(e => { 
            $('.select-wrapper span').text(e.currentTarget.innerText);
            let url = e.currentTarget.firstElementChild.dataset.link;
            window.location = url;
        });
    }
}

export default SixBarPageLogic;

$(() => {
	const sixBarPageLogic = new SixBarPageLogic();
	sixBarPageLogic.init();
});
